import { WIS_ADJUSTMENTS } from "../constants/abilityAdjustments";

export function calculateWisBonus(character) {

  let LookupKey = character.stats['myWis'].toString().replace(/[^0-9]/g, ''); // strip out non-numerical

  let WIS_bonus_string ="";
  try {
    const WIS_adj = WIS_ADJUSTMENTS[parseInt(LookupKey)]
      console.log('WIS adj: ',WIS_adj)

      let adjuster = WIS_adj['savingthrow'];
      const bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}` : `+${adjuster}`);
      console.log('Wis Saving Throw: ', bonus);

      WIS_bonus_string = bonus
      
      return { str: WIS_bonus_string, dict: WIS_adj }
    
  } catch(error) {
    console.log('fail gracefully')
    console.log(error)
  }

}